import React from 'react';
import ReactDOM from 'react-dom/client';
import { inject } from '@vercel/analytics';
import './index.css';
import App from './App';

inject();

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Hidratación condicional para react-snap (React 18):
// si el HTML ya fue prerenderizado (tiene hijos) usamos hydrateRoot,
// de lo contrario montamos normalmente con createRoot.
const rootEl = document.getElementById('root');
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, <App />);
} else {
  ReactDOM.createRoot(rootEl).render(<App />);
}